import { featureFlags } from "./featureConfig";
import { VENDOR_PATHS } from "./vendorNavPaths";

import {
  DvrOutlined,
  HomeOutlined,
  LogoutOutlined,
  NotificationsOutlined,
  PaidOutlined,
  PostAddOutlined,
  ReceiptOutlined,
  SettingsOutlined,
  ShoppingCartOutlined,
  SupportAgentOutlined,
} from "@mui/icons-material";

export const vendorMenuItems = [
  { text: "Dashboard", path: VENDOR_PATHS.DASHBOARD, icon: <HomeOutlined />, hidden: !featureFlags.enableDashboard, order: 1 },
  { text: "Notifiche", path: VENDOR_PATHS.NOTIFICHE, icon: <NotificationsOutlined />, hidden: !featureFlags.enableNotifiche, order: 2 },
  {
    text: "Catalogo",
    icon: <DvrOutlined />,
    hidden: false,
    order: 3,
    subItems: [
      { text: "Prodotti", path: VENDOR_PATHS.GESTIONE_PRODOTTI, icon: <ShoppingCartOutlined />, hidden: false },
      { text: "Caricamento CSV", path: VENDOR_PATHS.CATALOGO_CSV, icon: <PostAddOutlined />, hidden: false },
    ],
  },
  { text: "Ricariche", path: VENDOR_PATHS.RICARICHE, icon: <PaidOutlined />, hidden: !featureFlags.enableRicariche, order: 4 },
  { text: "Fatturazione", path: VENDOR_PATHS.FATTURAZIONE, icon: <ReceiptOutlined />, hidden: !featureFlags.enableFatturazione, order: 5 },
  { text: "Ticket", path: VENDOR_PATHS.TICKET, icon: <SupportAgentOutlined />, hidden: !featureFlags.enableTicket, order: 6 },
  { text: "Profilo", path: VENDOR_PATHS.PROFILO, icon: <SettingsOutlined />, hidden: false, order: 7 },
  { text: "Logout", path: VENDOR_PATHS.LOGOUT, icon: <LogoutOutlined />, hidden: false, order: 8 },
];

